import React from 'react';

import { createRoot } from 'react-dom/client';
import App from './global/App';
import './i18n';
import '@os/client-helpers/lib/global/moment/locale-config';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
